import { supabase } from "../lib/supabase";

export async function getUserProfile(uid: string, role: string) {
  const table = `${role}s`;
  const { data, error } = await supabase
    .from(table)
    .select("*")
    .eq("auth_user_id", uid)
    .maybeSingle();

  if (error) throw error;
  return data; // returns null if no row found, no error
}
